import React from 'react';
import About from '../components/About';
import '../styles/components/AboutPage.scss';

const AboutPage = () => {
  const scrollToAbout = () => {
    const aboutSection = document.querySelector('.about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const heroStats = [
    { number: '50+', label: 'Projects Completed', icon: 'fas fa-project-diagram' },
    { number: '40,000+', label: 'Respondents Reached', icon: 'fas fa-users' },
    { number: '40+', label: 'Districts Covered', icon: 'fas fa-map-marker-alt' },
    { number: '98%', label: 'Client Satisfaction', icon: 'fas fa-star' }
  ];

  // Inline styles for background images
  const heroStyle = {
    backgroundImage: `linear-gradient(135deg, rgba(26, 54, 93, 0.8) 0%, rgba(229, 62, 62, 0.6) 50%, rgba(221, 107, 32, 0.4) 100%), url('/images/about.jpg')`
  };

  const ctaStyle = {
    backgroundImage: `linear-gradient(135deg, rgba(26, 54, 93, 0.8) 0%, rgba(26, 54, 93, 0.9) 100%), url('/images/about.jpg')`
  };

  return (
    <div className="about-page">
      {/* Modern Hero Section with Background */}
      <section className="modern-hero" style={heroStyle}>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="badge">
                <span>Since 2021</span>
              </div>
              <h1>
                <span className="highlight-text">Simplifying</span> Service,
                <br />
                <span className="highlight-text">Elevating</span> Standards
              </h1>
              <p className="hero-description">
                We are a premier consulting firm redefining the landscape with modern, 
                innovative solutions that drive sustainable growth and organizational excellence.
              </p>
              
              <div className="hero-actions">
                <button className="btn-primary" onClick={scrollToAbout}>
                  <span>Discover Our Story</span>
                  <i className="fas fa-arrow-down"></i>
                </button>
                <a href="/contact" className="btn-secondary">
                  <i className="fas fa-paper-plane"></i>
                  Get In Touch
                </a>
              </div>
            </div>

            <div className="hero-visual">
              <div className="stats-grid">
                {heroStats.map((stat, index) => (
                  <div key={index} className="stat-card" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="stat-icon">
                      <i className={stat.icon}></i>
                    </div>
                    <div className="stat-content">
                      <div className="stat-number">{stat.number}</div>
                      <div className="stat-label">{stat.label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="scroll-indicator">
          <div className="scroll-line"></div>
          <span>Scroll to explore</span>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <About isHomepage={false} />
      </section>


      {/* Final CTA */}
      <section className="final-cta" style={ctaStyle}>
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Organization?</h2>
            <p>Partner with us to drive meaningful change and achieve sustainable results.</p>
            <div className="cta-buttons">
              <a href="/contact" className="btn btn-primary">
                <i className="fas fa-rocket"></i>
                Start Your Project
              </a>
              <a href="/services" className="btn btn-secondary">
                <i className="fas fa-chart-line"></i>
                View Our Services
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
